import cn from "clsx";
import React from "react";
import { Props } from "../index";
import { useTranslation } from "@/i18n/client";
import { sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25630";
import { EXPCONFIG_FAST } from "@/constants/point";
import callAfterLogin from "@/app/login/utils/callAfterLogin";
import FeedBackIcon from "@/assets/icons/feedback-icon.svg";
import floatingToolBtnStyle from "./FloatingToolBarBtn.module.scss";
import FeedbackTypeEnum from "@/components/feedback/feedbackType";
import(/* webpackPrefetch: true */ "@/components/feedback/feedbackController");

const JDIFeedbackBtn = ({ onOpen }: Props) => {

  const { t } = useTranslation();
  const handleFeedbackBtn = () => {
    sendClickTrack.Sidebar_Feedback_Click();
    callAfterLogin(async () => {
      try {
        const { default: FeedbackController } = await import("@/components/feedback/feedbackController");
        FeedbackController.getInstance().openFeedbackDialog(FeedbackTypeEnum.Feedback);
        onOpen && onOpen();
      } catch (error) {
        console.error("load feedback controller fail:", error);
      }
    });
  };

  return (
    <div exptag={"exp|" + EXPOSURE_RECORD.Sidebar_Feedback_Expo} data-exptag-config={EXPCONFIG_FAST}>
      <button className={cn(floatingToolBtnStyle.floatingBtn, floatingToolBtnStyle.heightNormal)} onClick={handleFeedbackBtn}>
        <div className={floatingToolBtnStyle.iconTextWrap}>
          <FeedBackIcon className={floatingToolBtnStyle.hoverIcon} />
        </div>
        <div className={floatingToolBtnStyle.btnText}>{t("floatingToolbar.feedback")}</div>
      </button>
    </div>
  );
};

export default JDIFeedbackBtn;
